import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { ptBR } from 'date-fns/locale';
import moment from 'moment';
import 'moment/locale/pt-br';

// Configurar moment para português brasileiro
moment.locale('pt-br');

// Registrar e definir o locale padrão para react-datepicker
registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export { ptBR };
